/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface MachinePart
 */
export interface MachinePart {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    type?: string;
    /**
     * 
     */
    machineId?: string;
    /**
     * 
     */
    areaId?: string;
    /**
     * 
     */
    machinePartTypeId?: string;
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    description?: string;
    /**
     * 
     */
    partNumber?: string;
    /**
     * 
     */
    createdAt?: Date;
    /**
     * 
     */
    updatedAt?: Date;
    /**
     * 
     */
    active?: boolean;
}

/**
 * Check if a given object implements the MachinePart interface.
 */
export function instanceOfMachinePart(value: object): value is MachinePart {
    return true;
}

export function MachinePartFromJSON(json: any): MachinePart {
    return MachinePartFromJSONTyped(json, false);
}

export function MachinePartFromJSONTyped(json: any, ignoreDiscriminator: boolean): MachinePart {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'machineId': json['machineId'] == null ? undefined : json['machineId'],
        'areaId': json['areaId'] == null ? undefined : json['areaId'],
        'machinePartTypeId': json['machinePartTypeId'] == null ? undefined : json['machinePartTypeId'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'partNumber': json['partNumber'] == null ? undefined : json['partNumber'],
        'createdAt': json['createdAt'] == null ? undefined : (parseDateTime(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (parseDateTime(json['updatedAt'])),
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function MachinePartToJSON(json: any): MachinePart {
    return MachinePartToJSONTyped(json, false);
}

export function MachinePartToJSONTyped(value?: MachinePart | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'machineId': value['machineId'],
        'areaId': value['areaId'],
        'machinePartTypeId': value['machinePartTypeId'],
        'name': value['name'],
        'description': value['description'],
        'partNumber': value['partNumber'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : serializeDateTime(value['createdAt']),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : serializeDateTime(value['updatedAt']),
        'active': value['active'],
    };
}

